module.exports = __webpack_public_path__ + "img/btn_LOW_lose.71a2fc9d.png";